var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResponseTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#7ED321",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 10.444a9.311 9.311 0 0 1-1 4.223 9.444 9.444 0 0 1-8.444 5.222 9.311 9.311 0 0 1-4.223-1L1 21l2.111-6.333a9.311 9.311 0 0 1-1-4.223A9.444 9.444 0 0 1 7.333 2a9.311 9.311 0 0 1 4.223-1h.555A9.422 9.422 0 0 1 21 9.889v.555z",
    fill: "#7ED321",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.687 8.222l-4.445 4.445-2.02-2.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 10.444a9.311 9.311 0 0 1-1 4.223 9.444 9.444 0 0 1-8.444 5.222 9.311 9.311 0 0 1-4.223-1L1 21l2.111-6.333a9.311 9.311 0 0 1-1-4.223A9.444 9.444 0 0 1 7.333 2a9.311 9.311 0 0 1 4.223-1h.555A9.422 9.422 0 0 1 21 9.889v.555z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponseTimeIcon);
export default __webpack_public_path__ + "static/media/responseTimeIcon.33dd4555.svg";
export { ForwardRef as ReactComponent };